{% block sw_desktop_sidebar %}
    <sw-admin-menu v-if="!noNavigation"/>

    <moorl-feature-unlocker/>
{% endblock %}